<template>
  <div>积分明细</div>
</template>

<script>
export default {

}
</script>

<style>

</style>